import React, { useState } from "react";
import { useEffect } from "react";
import adv1 from "../Assets/activity/adv1.jpg";
import adv2 from "../Assets/activity/adv2.jpg";
import adv3 from "../Assets/activity/adv3.jpg";
import adv4 from "../Assets/activity/adv4.jpg";
import cul1 from "../Assets/activity/cul1.jpg";
import cul2 from "../Assets/activity/cul2.jpg";
import cul3 from "../Assets/activity/cul3.jpg";
import cul4 from "../Assets/activity/cul4.jpg";
import cul5 from "../Assets/activity/cul5.jpg";
import din1 from "../Assets/activity/din1.jpg";
import din2 from "../Assets/activity/din2.jpg";
import din3 from "../Assets/activity/din3.jpg";
import din4 from "../Assets/activity/din4.jpg";



const Adventure = () => {
  const [currentItem, setCurrentItem] = useState(1); // Start with the first item
  const totalItems = 4; // Total number of items in the gallery

  useEffect(() => {
    // Automatically switch to the next item every 3 seconds
    const interval = setInterval(() => {
      setCurrentItem((prevItem) => (prevItem % totalItems) + 1);
    }, 3000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [totalItems]);

  return (
    <div id="gallery" className="relative overflow-hidden rounded-lg md:h-48">
      {/* Use currentItem to conditionally render the active item */}
      <div
        className={
          currentItem === 1
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 1 ? "active" : ""}
      >
        <img
          src={adv1}
          className="object-contain absolute inline max-w-full h-max -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>

      <div
        className={
          currentItem === 2
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 2 ? "active" : ""}
      >
        <img
          src={adv2}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
      <div
        className={
          currentItem === 3
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 3 ? "active" : ""}
      >
        <img
          src={adv3}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
      <div
        className={
          currentItem === 4
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 4 ? "active" : ""}
      >
        <img
          src={adv4}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
    </div>
  );
};

const Culture = () => {
  const [currentItem, setCurrentItem] = useState(1); // Start with the first item
  const totalItems = 3; // Total number of items in the gallery

  useEffect(() => {
    // Automatically switch to the next item every 3 seconds
    const interval = setInterval(() => {
      setCurrentItem((prevItem) => (prevItem % totalItems) + 1);
    }, 3000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [totalItems]);

  return (
    <div id="gallery" className="relative overflow-hidden rounded-lg md:h-48">
      {/* Use currentItem to conditionally render the active item */}
      <div
        className={
          currentItem === 1
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 1 ? "active" : ""}
      >
        <img
          src={cul1}
          className="object-contain absolute inline max-w-full h-max -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>

      <div
        className={
          currentItem === 2
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 2 ? "active" : ""}
      >
        <img
          src={cul2}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
      <div
        className={
          currentItem === 3
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 3 ? "active" : ""}
      >
        <img
          src={cul3}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
      <div
        className={
          currentItem === 4
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 4 ? "active" : ""}
      >
        <img
          src={cul4}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
      <div
        className={
          currentItem === 5
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 5 ? "active" : ""}
      >
        <img
          src={cul5}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
    </div>
  );
};

const Dining = () => {
  const [currentItem, setCurrentItem] = useState(1); // Start with the first item
  const totalItems = 4; // Total number of items in the gallery

  useEffect(() => {
    // Automatically switch to the next item every 3 seconds
    const interval = setInterval(() => {
      setCurrentItem((prevItem) => (prevItem % totalItems) + 1);
    }, 3000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [totalItems]);

  return (
    <div id="gallery" className="relative overflow-hidden rounded-lg md:h-48">
      {/* Use currentItem to conditionally render the active item */}
      <div
        className={
          currentItem === 1
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 1 ? "active" : ""}
      >
        <img
          src={din1}
          className="object-contain absolute inline max-w-full h-max -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>

      <div
        className={
          currentItem === 2
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 2 ? "active" : ""}
      >
        <img
          src={din2}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
      <div
        className={
          currentItem === 3
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 3 ? "active" : ""}
      >
        <img
          src={din3}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
      <div
        className={
          currentItem === 4
            ? "duration-500 ease-in-out"
            : "hidden duration-500 ease-in-out"
        }
        data-carousel-item={currentItem === 4 ? "active" : ""}
      >
        <img
          src={din4}
          className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          alt=""
        />
      </div>
    </div>
  );
};

export default function PopularTrips() {
  return (
    <div className="max-w-6xl mx-auto h-full p-6 rounded-xl">
      <h3 class="mb-4 mt-0  p-8 text-3xl font-medium leading-tight text-gray-700 text-center text-primary ">
        Travel Preferences
      </h3>
      <div class="grid-cols-1 sm:grid md:grid-cols-3 gap-4 ">
        <div className="max-w-6xl mx-auto h-full border border-gray-300 shadow-md p-2 rounded-xl hover:shadow-lg hover:shadow-black/30">
          <div
            class="mx-3 mt-6 flex flex-col rounded-lg bg-white text-surface shadow-secondary-1  sm:shrink-0 sm:grow sm:basis-0
   shadow-none transition-shadow duration-300 ease-in-out "
          >
            <a href="/form">
              <Adventure />
            </a>
            <div class="p-6">
              <h5 class="mb-2 text-xl font-medium leading-tight">Adventure</h5>
              <p class="mb-4 text-base">
                For those seeking adrenaline-pumping adventures like skydiving,
                bungee jumping, and white-water rafting.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto h-full border border-gray-300 shadow-md p-2 rounded-xl hover:shadow-lg hover:shadow-black/30">
          <div
            class="mx-3 mt-6 flex flex-col rounded-lg bg-white text-surface shadow-secondary-1  sm:shrink-0 sm:grow sm:basis-0
     shadow-none transition-shadow duration-300 ease-in-out "
          >
            <a href="/form">
              <Culture />
            </a>
            <div class="p-6">
              <h5 class="mb-2 text-xl font-medium leading-tight">
                Art and Culture
              </h5>
              <p class="mb-4 text-base">
                Explore local traditions, arts, folklore, UNESCO World Heritage
                Sites, ancient ruins, and cultural landmarks.
              </p>
            </div>
          </div>
        </div>
        <div className="max-w-6xl mx-auto h-full border border-gray-300 shadow-md p-2 rounded-xl hover:shadow-lg hover:shadow-black/30">
          <div
            class="mx-3 mt-6 flex flex-col rounded-lg bg-white text-surface shadow-secondary-1  sm:shrink-0 sm:grow sm:basis-0
     shadow-none transition-shadow duration-300 ease-in-out "
          >
            <a href="/form">
              <Dining />
            </a>
            <div class="p-6">
              <h5 class="mb-2 text-xl font-medium leading-tight">Dining</h5>
              <p class="mb-4 text-base">
                Tantalize your taste buds with the falvors of continental
                cuisine to the vibrant chaos of local street food.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
